<template>
  <div class="container-box">
    <div class="p-1">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center mb-05">
          <b-avatar :src="assistant.image ? getAssetUrl(assistant.image) : assistant.image_url"></b-avatar>
          <div class="d-flex flex-column ml-05">
            <strong>{{ assistant.name }}</strong>
            <p class="avenir-light m-0">{{ $t('ia.type_assistant').find((i) => i.value === assistant.type_assistant).text }}</p>
          </div>
        </div>
        <b-dropdown variant="flat-secondary" no-caret class="dropdown-personas-brandme-ia" v-if="!is_public">
        <template #button-content>
          <feather-icon icon="MoreVerticalIcon"></feather-icon>
        </template>
          <b-dropdown-item @click="$emit('edit_assistant', assistant)">
            <div class="d-flex justify-content-between align-items-center">
              <span class="d-block">{{ $t('edit') }}</span>
              <feather-icon icon="EditIcon" class="d-block"></feather-icon>
            </div>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="$emit('delete_assistant', assistant.uuid)">
            <div class="d-flex justify-content-between align-items-center">
              <span class="d-block">{{ $t('delete') }}</span>
              <feather-icon icon="TrashIcon" class="d-block"></feather-icon>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <p class="mb-05 avenir-medium ellipsis">{{ assistant.description }}</p>
      <b-badge class="badge-custom gray-badge">{{ $t('ia.formality').find((i) => i.value === assistant.responses_ai.formality).text }}</b-badge>
      <b-badge class="badge-custom danger-badge">{{ $t('ia.bias').find((i) => i.value === assistant.responses_ai.bias).text }}</b-badge>
      <b-badge class="badge-custom success-badge">{{ $t('ia.response_length').find((i) => i.value === assistant.responses_ai.response_length).text }}</b-badge>
      <div class="meta mt-1 " v-if="hasDetails(assistant) || hasGoals(assistant)">
        <div class="meta-group" v-if="hasDetails(assistant)">
          <div class="meta-title">{{ $t('dashboard.profile') }}</div>
          <dl class="kv">
            <div v-if="assistant.details.age">
              <dt>{{$t('dashboard.age')}}</dt>
              <dd>{{ assistant.details.age }}</dd>
            </div>
            <div v-if="assistant.details.gender">
              <dt>{{$t('dashboard.gender')}}</dt>
              <dd>{{ assistant.details.gender }}</dd>
            </div>
            <div v-if="assistant.details.occupation">
              <dt>{{$t('ia.text.persona_occupattion')}}</dt>
              <dd>{{ assistant.details.occupation }}</dd>
            </div>
            <div v-if="assistant.details.intellect">
              <dt>{{$t('ia.text.persona_intellect')}}</dt>
              <dd>{{ assistant.details.intellect }}</dd>
            </div>
            <div v-if="assistant.details.mindset">
              <dt>{{$t('ia.text.persona_mindset')}}</dt>
              <dd>{{ assistant.details.mindset }}</dd>
            </div>
          </dl>
        </div>

        <div class="meta-group" v-if="hasGoals(assistant)">
          <div class="meta-title">{{ $t('ia.assistants.goals') }}</div>
          <ul class="goals">
            <li v-if="assistant.goals.primary_goal"><strong>{{ $t('ia.assistants.primary') }}:</strong> {{ assistant.goals.primary_goal }}</li>
            <li v-if="assistant.goals.secondary_goal"><strong>{{ $t('ia.assistants.secondary') }}:</strong> {{ assistant.goals.secondary_goal }}</li>
          </ul>
        </div>
      </div>
    </div>
    <b-button class="button-action-use" variant="button-action-use" @click="useAssistant" v-if="active_assistant_uuid !== assistant.uuid">{{ $t('ia.assistants.usePersona') }}</b-button>
    <b-button class="button-action-use success-button-disabled" @click="useAssistant" variant="button-action-use" v-else>{{ $t('ia.assistants.activePersona') }}</b-button>

  </div>
</template>      
<script>
import {
  BAvatar,
  BButton,
  BBadge,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
} from 'bootstrap-vue';
import { getAssetUrl } from '@/libs/utils/urls';
import { activateAssistant } from '@/services/ia';
    
export default {
  name: 'CardAssistant',
  components: {
    BAvatar,
    BButton,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BBadge,
  },
  props: {
    assistant: {
      type: Object,
      default: () => {}
    },
    is_public: {
      type: Boolean,
      default: false
    },
    active_assistant_uuid: {
      type: String,
      default: null
    }
  },
  methods: {
    hasDetails(a) {
      return !!a.details && Object.keys(a.details).some(k => (a.details)[k])
    },
    hasGoals(a) {
      return !!a.goals && (a.goals) && ((a.goals).primary_goal || (a.goals).secondary_goal)
    },
    useAssistant() {
      const data = this.active_assistant_uuid !== this.assistant.uuid ? { person_assistant_uuid: this.assistant.uuid } : {};
      activateAssistant(data).then((response) => {
        this.$emit('update_active_assistant', response);
      });
    }
  },
  data() {
    return {
      getAssetUrl,
    }
  }
}
</script>
<style lang="scss" scoped>
  
  .container-box {
    border: 1px solid rgb(229.5, 229.5, 229.5);
    border-radius: 5px;
    // height: 190px;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .ml-05 {
      margin-left: 0.5em;
    }
    .mb-05 {
      margin-bottom: 0.5em;
    }

    .badge-custom {
      color: #444;
      margin-right: 1em;
      text-transform: uppercase;
      padding: .8em 1em;
      white-space: nowrap;
      // height: 20px;
      font-size: .58rem;
      border-radius: 20em;
      vertical-align: baseline;
      text-align: center;
      
    }
    .gray-badge {
      background-color: rgba(144,40,117,.1);
    }
    .danger-badge {
      background-color: rgba(220,53,69,.1);
    }
    .success-badge {
      background-color: rgba(40,167,69,.1);
    }
    .button-action-use {
      border-radius: 0 0 5px 5px;
      border: none;
      border-top: 1px solid #e6e6e6 !important;
      background-color: rgb(233.4,241.9,245.1);
      color: rgb(31.2,99.2,124.8);
      height: 40px;
      font-family: 'avenir-medium', sans-serif;
      &:hover {
        background-color: rgb(33, 152, 191);
        color: white;
      }

    }
    .success-button-disabled {
      background-color: rgb(208, 237, 226);
      color: rgb(41.6,104,82.4); 
      &:hover {
        background-color: rgba(208, 237, 226, 0.815);
        color: rgb(41.6,104,82.4); 
      }
      &:active {
        background-color: rgb(208, 237, 226);
        color: rgb(41.6,104,82.4); 
      }
    }

    .meta {
      display: grid;
      gap: 8px;
      padding-bottom: 8px;
    }

    .meta-group {
      border-top: 1px solid #f3f4f6;
      padding-top: 10px;
    }

    .kv>div {
      display: grid;
      grid-template-columns: 95px 1fr;
      gap: 6px;
      align-items: baseline;
      font-size: 13px;
    }

    .kv dt {
      color: #6b7280;
      font-weight: 600;
    }

    .kv dd {
      margin: 0;
      color: #374151;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .goals {
      margin: 0;
      padding-left: 16px;
      list-style: disc;
      color: #374151;
      font-size: 13px;
    }

    .goals li {
      margin: 2px 0;
    }

    .meta-title {
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: .04em;
      color: #6b7280;
      margin-bottom: 6px;
    }
    .ellipsis {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  </style>
  <style lang="scss">
  .dropdown-personas-brandme-ia {
    button {
      padding: 0.3em 0.7em !important;
      border: 1px solid #e6e6e6 !important;
      height: 40px !important;
    }
  }
  </style>